import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr19 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За използване на работно оборудване в т.ч лични и колективни предпазни средства при работа
        по въздушни и кабелни съобщителни линии и мрежи, и при работа с напрежение до 1000V
      </Typography>

      <Typography>
        <b>Изисквания към техническия екип:</b>
      </Typography>

      <Typography>
        Техническият екип се състои от минимум двама техници, единият от които изпълнява ролята на
        ръководител екип (група). Със знанието на координатора/гл. техник или техническия
        супервайзор и запис в работния график, в зависимост от обема на работа и риска при работата,
        е възможно групата да се състои от един човек, при положение, че няма да се извършва
        инсталация или отстраняване на клиентски проблем при наличие на външна мрежа (въздушна или
        на фасада).
      </Typography>

      <Typography>
        Минималната квалификационна група по електробезопасност на техниците е трета. Допуска се
        единия от членовете на екипа да бъде с втора група, ако последния не извършва самостоятелна
        работа.
      </Typography>

      <Typography>
        Обучението и демонстриране, за използването и съхраняването на личните предпазни средства на
        новопостъпили техници се осъществава по време на въвеждащото и практическо обучение от
        страна на техник, които изпълнява ролята на ръководител екип (група).
      </Typography>

      <Typography>
        Отговорност на ползвателите е да следят състоянието на специализираните лични и колективни
        предпазни средства, преди, по време и след всяка употреба.
      </Typography>

      <Typography>
        <b>Основни принципи при работа: </b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Преди започване на конкретната задача е необходимо: </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се извърши основен оглед на обекта
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се прецени какви са рисковете при работа
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - до се уточни какви предпазни средства да се използват по време на конкретната задача
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          2. <span style={styles.warning}>Забранено е:</span>
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се работи без работно облекло, без специални обувки, без калцуни за обувките в
          помещенията
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при работа на височина над 1,5 м. мерено от терена до краката на служителя да се работи
          без каска
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се използват неизправни стълби, стълби с конструкция или изпълнения, неотговарящи на
          нормативните актове, стандартите и техническите условия
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - забранено е да се работи с неизолирани фазомери, клещи, инструменти{' '}
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се работи с пробивни инструменти без изолирани ръкохватки
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се работи по въздушни и кабелни съобщителни линии и мрежи по време на активна
          атмосферна /мълниеносна/ дейност, силен снеговалеж, ниски температури на въздуха, заледени
          и необезопасени работни места.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Задължително е:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се проверяват отделните елементи и конектори за наличие на потенциал чрез фазомер.
          При наличие на такъв продължете работата си само с изолирани инструменти като спазвате
          стриктно изискванията по електробезопасност съгласно Инструкция №1!
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при изграждане на ново трасе при пробиване се разглежда мястото за наличие на
          силнотокови кабели, водопроводи или др. Работи се с изолационните дръжки на пробивните
          инструменти, като след направата на отвор се проверява визуално за коректността на отвора,
          а ако става въпрос за закрепване на кабела с метални крепежни елементи или към метални
          корпуси с фазомер се проверява наличие на потенциал на тях.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се проверява състоянието на всички контакти, към които се свързват телевизионните и
          цифрови приемници, компютри, системи за домашно кино и др. Проверяват се и всички близко
          стоящи контакти.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при съмнение за наличие на напрежение на вътрешната мрежа или при невъзможност да бъде
          изключено се работи само с изолирани инструменти и диелектрични ръкавици
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при поставяне на стълба върху стената на фасадата задължително да се укрепи срещу
          приплъзване
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се спазват стриктно мерките за безопасност при работа с преносими стълби и по
          стълбове съгласно вътрешна Инструкция №2 и Инструкция №3
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          Инструкция №1 за ел. безопасност при присъединавяне на нов нов клиент или отстраняване на
          клиентски проблем в кабелната мрежа на А1
        </b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>Инструкция №2 за безопасност при работа с преносими стълби</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>Инструкция №3 за безопасност при работа по стълбове</b>
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr19;
